exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox {\n  height: 15px;\n  width: 15px;\n}\n", ""]);

// exports
